import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { ButtonComponent, DialogFooterComponent, DialogHeaderComponent } from '@akostm/orbit-ui';

@Component({
  selector: 'lib-webhook-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    ButtonComponent,
    DialogHeaderComponent,
    DialogFooterComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './webhook-dialog.component.html',
  styleUrls: ['./webhook-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class WebhookDialogComponent {
  dialogRef = inject(DialogRef);
  data: any = inject(DIALOG_DATA);

  closeDialog(save: boolean): void {
    this.dialogRef.close(save);
  }
}
